// extracted by mini-css-extract-plugin
export default {"editInfoWrapper":"edit_editInfoWrapper__0nxfu","editInfo":"edit_editInfo__i-Khu","titleSect":"edit_titleSect__DpO4+","title":"edit_title__UPkWa","info":"edit_info__WOBNn"};